import React from "react";
import { DashboardHelper } from "../_helpers";

export function WidgetSettingsComponent({ widgetType, ...otherProps }) {
    const WidgetSettingsModule = DashboardHelper.settingsModuleForWidgetType(widgetType);
    return <WidgetSettingsModule {...otherProps} />
}